import React from "react";
import "./processsection.css";

const ProcessSection = ({ data }) => {
  return (
    <section className="process-section">
      <div className="process-section__container">

        {/* Section Heading */}
        <div className="process-section__heading">

          <div className="process-section__accent"></div>

          <div className="process-section__heading-content">

            {data.sectionLabel && (
              <div className="process-section__label">
                {data.sectionLabel}
              </div>
            )}

            <h2>{data.heading}</h2>

          </div>

        </div>

        {/* Process Cards */}
        <div className="process-section__grid">

          {data.cards.map((card) => (
            <article
              className="process-card"
              key={card.id}
            >

              {/* Number */}
              <div className="process-card__number">
                {card.number}
              </div>

              {/* Content */}
              <div className="process-card__content">

                <h3>{card.title}</h3>

                {card.subtitle && (
                  <div className="process-card__subtitle">
                    {card.subtitle}
                  </div>
                )}

                <p className="process-card__description">
                  {card.description}
                </p>

                {/* Points */}
                {card.points?.length > 0 && (
                  <ul className="process-card__points">

                    {card.points.map((point, index) => (
                      <li key={index}>
                        <span className="process-card__bullet">
                          ◆
                        </span>

                        <span>{point}</span>
                      </li>
                    ))}

                  </ul>
                )}

              </div>

            </article>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ProcessSection;